import { MainWindow } from '../chat/types';
import { Nullable } from '../types';
import { sendTextToVoiceAgent } from './eleven-labs';
import { startVoiceSession, stopVoiceSession } from './speech';
import { templateTextWidget } from './template';

import { VoiceUIElements } from './types';

const widget = document.createElement('template');
widget.innerHTML = templateTextWidget;

class WitzoVoiceElement extends HTMLElement {
  /**Url to connect to the webhook */
  _agentId: Nullable<string> = null;

  /**Reference for elements */
  chat: Nullable<VoiceUIElements> = null;

  /**Is Initialized */
  isInitialized: boolean = false;

  /**Checks if mic is on or not */
  isMicActive: boolean = false;
  isConversationStarted: boolean = false;
  _mainWindow: MainWindow;

  constructor() {
    super();
    const node = widget.content.cloneNode(true);
    //Assume no outside influence on the styling should be possible
    const root = this.attachShadow({ mode: 'closed' });
    root.appendChild(node);

    this.getElements(root);

    this._mainWindow = {
      back: () => {},
      close: () => {},
    };

    if (this.chat) {
      this.chat.input.disabled = true;
      this.chat.input.placeholder = 'Start Conversation to enter details ';
    }
  }

  /**
   * @description retrieve elements from shadow dom and ensures initialization
   */
  private getElements(root: ShadowRoot) {
    const q = <T extends HTMLElement | SVGSVGElement|SVGPathElement>(selector: string) =>
      root.querySelector(selector) as T;

    try {
      this.chat = {
        backButton: q('#backToSelection'),
        chatWindow: q('#chatWidget'),
        closeButton: q('#closeVoiceChat'),
        micButton: q('#voiceMicButton'),
        messagesContainer: q('#voiceTranscript'),
        endButton: q('#endVoiceCall'),
        status: q('#voiceStatusText'),
        waves: {
          root: q('#voiceVisualizerBars'),
          wavelets: Array.from(root.querySelectorAll('.voice-wave')) as HTMLDivElement[],
        },
        sendButton: q('#textSendButton'),
        input: q('#textMessageInput'),
        icons: {
          startChat: q('#start-icon'),
          endChat: q('#end-icon'),
        
          micStartIcon:q('#mic-start-icon'),
          micEndIcon:q('#mic-end-icon'),
        },
      };
      this.isInitialized = true;

      this.chat.icons.micStartIcon.style.fill='';
      this.chat.icons.micEndIcon.style.fill='';
    } catch (err) {
      this.isInitialized = false;
      console.warn(`Couldn't initialize ${err}`);
    }
  }

  /**
   * @description external function to set the url to connect to web-hook
   */
  set agentId(id: string) {
    this._agentId = id;
  }

  set mainWindow(_mainWindow: MainWindow) {
    this._mainWindow = _mainWindow;
  }

  set iconColors(icons:{
    iconColors:Nullable<string>
  }){
    if(!this.chat) return;

    this.chat.micButton.style.borderColor=icons.iconColors ?? '#FC0E3F'
    this.chat.micButton.style.boxShadow=`0 0 16px ${icons.iconColors ?? '#FC0E3F'}`
    this.chat.icons.micStartIcon.style.fill=icons.iconColors ?? '#FC0E3F';
    this.chat.icons.micEndIcon.style.stroke=icons.iconColors ?? '#FC0E3F';
    this.chat.sendButton.style.backgroundColor=icons.iconColors ?? '#FC0E3F';
    this.chat.micButton.style.setProperty('--pulse-color',icons.iconColors)
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    if (!this.chat || this.isInitialized === false) return;
    const {
      backButton,
      chatWindow,
      closeButton,
      endButton,
      micButton,
      status,
      waves,
      sendButton,
      input,
    } = this.chat;

    backButton.addEventListener('click', () => {
      this.setMicUIState(false);
      stopVoiceSession(status, waves.root);
      if (this._mainWindow) this._mainWindow.back();
      if (chatWindow) chatWindow.classList.add('hidden');
    });

    closeButton.addEventListener('click', () => {
      this.setMicUIState(false);
      stopVoiceSession(status, waves.root);
      this._mainWindow.close();
    });

    micButton.addEventListener('click', async () => await this.toggleMic());

    sendButton.addEventListener('click', () => {
      sendTextToVoiceAgent(input);
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        sendButton.click();
      }
    });
  }

  private setMicUIState(active: boolean) {
    if (!this.chat) return;

    const { status } = this.chat;
    status.textContent = active ? 'Establishing Connection...' : 'Terminating Connection...';
  }

  async toggleMic() {
    if (!this._agentId || !this.chat) return;

    const { micButton, status, waves, messagesContainer, input, icons, sendButton } = this.chat;
    micButton.classList.toggle('active');

    try {
      if (!this.isMicActive) {
        input.disabled = false;
        this.chat.input.placeholder = 'Type your message...';
        micButton.disabled = true;

        this.setMicUIState(true);
        startVoiceSession(
          this._agentId,
          status,
          waves.root,
          waves.wavelets,
          messagesContainer,
          micButton
        );
        icons.startChat.classList.add('hidden');
        icons.endChat.classList.remove('hidden');
        input.classList.remove('chat-visibility');
        sendButton.classList.remove('chat-visibility');
      } else {
        input.disabled = true;
        this.setMicUIState(false);
        this.chat.input.placeholder = 'Start Conversation to Enter Details ';
        stopVoiceSession(status, waves.root);
        icons.startChat.classList.remove('hidden');
        icons.endChat.classList.add('hidden');
        input.classList.add('chat-visibility');
        sendButton.classList.add('chat-visibility');
      }

      this.isMicActive = !this.isMicActive;
    } catch (err) {
      console.error(`Error while mic toggle ${err}`);
      status.textContent = 'Error Occured. Please Try Again';
      this.isMicActive = !this.isMicActive;
    } finally {
      //micButton.disabled = false;
    }
  }
}

export { WitzoVoiceElement };

